'use strict';

import React, { Fragment } from 'react'

import _ from 'lodash'

import CustomQuoteText     from '@/CustomQuote/CustomQuoteText'
import CustomQuoteTextarea from '@/CustomQuote/CustomQuoteTextarea'
import CustomQuoteSelect   from '@/CustomQuote/CustomQuoteSelect'
import CustomQuoteCheckbox from '@/CustomQuote/CustomQuoteCheckbox'

let app = window.app;

export default class CustomQuoteElements extends React.Component
{
	constructor (props)
	{
		super(props);

		this.state = { };

		this.handleElementDeletion = this.handleElementDeletion.bind(this);
	}

	handleElementDeletion (id)
	{
		const component = this, props = this.props, state = this.state;

		if (props.onDeletion instanceof Function)
		{
			props.onDeletion(id);
		}
	}

	render ()
	{
		const component = this, props = this.props, state = this.state;

		const status = props.status || { };

		let elements = (props.elements || []).map(function (element, id)
		{
			const Component = getElementComponent(element.type);

			let delete_btn, update_btn;

			if (props.onDeletion instanceof Function)
			{
				delete_btn =
				(
					<button type="button" className="c-custom-quote__delete-element"
						onClick={ function (e)
							{ component.handleElementDeletion(element.id || id) } }>
						Supprimer l'élément
					</button>
				);
			}

			if (props.updatable === true)
			{
				update_btn =
				(
					<button type="button" className="c-custom-quote__update-element"
						onClick={ function (e)
							{
								app.emit('open__CustomQuoteItemModal',
									_.merge(_.cloneDeep(element), { _index: id })); }
							}>
						<svg className="o-svg-icon o-svg-icon--modify c-custom-quote__update-icon">
							<use xlinkHref="/images/icons.svg#svg-icon-modify"></use>
						</svg>

						<span className="c-custom-quote__update-label">
							Modifier
						</span>
					</button>
				);
			}

			let class_name = 'o-grid__item';

			if (delete_btn) class_name += ' u-flex u-items-end';

			if (element.type === 'checkbox') class_name += ' u-flex-wrap';

			return (
				<div key={ id } className={ class_name }>
					<Component editable={ props.editable } onChange={ props.onChange }
						element={ element } data={ props.form_data } id={ element.id }
						status={ status['custom_quote[' + element?.id + ']'] } />

					{ update_btn }
					{ delete_btn }
				</div>
			);
		});

		if (elements.length)
		{
			return (
				<div className="u-full-width">
					<div className="u-negative-margins">
						<div className="o-grid-3 u-margin-bottom-20">
							{ elements }
						</div>
					</div>
				</div>
			);
		}

		return elements;
	}
}

function getElementComponent (type)
{
	if (type === 'textarea')
	{
		return CustomQuoteTextarea;
	}
	else if (type === 'select')
	{
		return CustomQuoteSelect;
	}
	else if (type === 'checkbox')
	{
		return CustomQuoteCheckbox;
	}
	else
	{
		return CustomQuoteText;
	}
}